<ng-container *pyContainerSize="{ min: 600 }; ref: elementRef; else: list">
  <table [ngClass]="{ 'table-grey mt-6': !pdpTypeSkuPicker, table: pdpTypeSkuPicker }">
    <thead>
      <tr [ngClass]="{ 'font-secondary': pdpTypeSkuPicker }">
        <th class="pl-3" scope="row">{{ headerAttributes.attribute.name }}</th>
        <th scope="row">{{ headerAttributes.attribute.isoCode }}</th>
        <th scope="row">{{ headerAttributes.attribute.unit }}</th>
        <th scope="col" *ngFor="let values of headerAttributes.values">{{ values }}</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of attributes | slice: 1">
        <th class="pl-3" scope="row">{{ row.attribute.name }}</th>
        <td>{{ row.attribute.isoCode }}</td>
        <td>{{ row.attribute.unit }}</td>
        <td *ngFor="let values of row.values">{{ values }}</td>
      </tr>
    </tbody>
  </table>
</ng-container>

<ng-template #list>
  <ng-container *ngIf="pdpTypeSkuPicker; else templateNoSkuPicker">
    <div class="list-header p-3">
      <h3 class="h6">{{ 'product.grammage_heading' | cxTranslate }}</h3>
    </div>
    <ul>
      <li *ngFor="let row of listItems" class="border-bottom list-body p-3">
        <div class="d-flex justify-content-between font-secondary mb-2 pt-2">
          <span>{{ row.name }}</span> {{ row.isoCode }}
        </div>
        <div *ngFor="let value of row.values" class="d-flex justify-content-between pb-1">
          <span>{{ value.attribute.name }}: {{ value.value }} {{ value.attribute.unit }}</span> {{ value.attribute.isoCode }}
        </div>
      </li>
    </ul>
  </ng-container>

  <ng-template #templateNoSkuPicker>
    <div class="mt-7 table-grey-list">
      <div class="table-grey-list-header p-3">
        <h3 class="h6">{{ 'product.grammage_heading' | cxTranslate }}</h3>
      </div>
      <ul>
        <li *ngFor="let row of listItems" class="border-bottom p-3">
          <div class="table-grey-list-row-header d-flex justify-content-between py-3">
            <span>{{ row.name }}</span> {{ row.isoCode }}
          </div>
          <div *ngFor="let value of row.values" class="d-flex justify-content-between pb-1">
            <span>{{ value.attribute.name }}: {{ value.value }} {{ value.attribute.unit }}</span> {{ value.attribute.isoCode }}
          </div>
        </li>
      </ul>
    </div>
  </ng-template>
</ng-template>
